import { ClientTypes } from '~/constants/clientTypes';

export const nonProfitTableColumns = [
  {
    title: 'Код ознаки неприбутковості',
    size: 3,
  },
  {
    title: 'Дата рішення',
    size: 3,
  },
  {
    title: 'Номер рішення',
    size: 3,
  },
  {
    title: 'Орган реєстрації',
    size: 3,
  },
];

export const clarifyingInfoColumns = [
  {
    title: '№',
    size: 0.5,
  },
  {
    title: 'Питання',
    size: 3.5,
  },
  {
    title: 'Варіант відповіді',
    size: 4,
  },
  {
    title: 'Додаткова інформація',
    size: 4,
  },
];

export const infoContactsTableColumns = [
  {
    title: "Ім'я та прізвище",
    size: 4,
  },
  {
    title: 'Номер контактного телефону',
    size: 4,
  },
  {
    title: 'Адреса електронної пошти',
    size: 3,
  },
];

export const SOLE_TRADER_MULTISELECT_IDS = [2, 3, 6, 7];
export const LEGAL_RESIDENT_MULTISELECT_IDS = [...SOLE_TRADER_MULTISELECT_IDS, 17, 18];
export const TRANSPORT_ANSWER_IDS = [45, 46];
export const DISABLED_ANSWERS = [
  14, 16, 18, 24, 25, 26, 27, 29, 30, 31, 32, 33, 34, 39, 41, 44, 47, 53, 52,
];

export const EMPTY_NON_PROFIT = {
  code: '',
  decisionDate: null,
  decisionNumber: '',
  registrationAuthority: '',
};

export const EMPTY_INFO_CONTACTS = {
  name: '',
  phone: '',
  email: '',
};

export const BUSINESS_RELATIONS_SOLE_TRADER_TEXT = {
  textTooltipBusinessDescription:
    'Інформацію надавати стисло, у вигляді пояснення(текст) про реальне/фактичне чи заплановане ведення господарської діяльності',
  serviceHeaderText:
    'Послуги, продукти (операції), які фізична особа підприємець/особа, що здійснює незалежну професійну діяльність планує отримувати / проводити в АТ «Укрексімбанк»',
  isPremisesInConflictZoneText:
    'Чи наявні виробничі/офісні приміщення на територіях, на яких ведуться активні бойові дії або які є тимчасово окупованими російською федерацією територіями України?',
};

export const BUSINESS_RELATIONS_LEGAL_RESIDENT_TEXT = {
  textTooltipBusinessDescription: 'Опишіть своїми словами зміст та суть господарської діяльності',
  serviceHeaderText:
    'Послуги, продукти (операції), які юридична особа планує отримувати / проводити в АТ «Укрексімбанк»',
  isPremisesInConflictZoneText:
    'Чи наявні виробничі/офісні приміщення на територіях, на яких ведуться активні бойові дії або які є тимчасово окупованими російською федерацією територіями України (далі-ТОТ)?',
};
export const PREMISES_TYPES = ['Виробничі', 'Офісні', 'Інші (господарські, тощо)'];

export const testDataBusinessRelationsSoleTrader = {
  businessDescription: 'Опис змісту та суті діяльності',
  typesOfActivity: { value: '786202', label: '62.02 - Консультування з питань інформатизації' },
  type: ClientTypes.SOLE_TRADER,
  isPremisesInConflictZone: false,
  cashManagement: false,
  loans: true,
  deposits: false,
  tradeFinanceAndDocumentaryOperations: false,
  securitiesOperations: false,
  paymentCards: false,
  explanation: [
    {
      answers: [{ value: '4', label: 'зазначити інше', comments: [{ general: 'інше' }] }],
      questionId: 1,
    },
    {
      answers: [
        {
          value: '36',
          label: 'торгівельні точки за адресою:',
          comments: [{ general: 'вул. Хрещатик 23' }],
        },
      ],
      questionId: 2,
    },
    {
      answers: [{ value: '11', label: 'магазин', comments: [{ general: 'Зара' }] }],
      questionId: 3,
    },
    {
      answers: [{ value: '14', label: 'не належу до Групи компаній', comments: [{ general: '' }] }],
      questionId: 4,
    },
    {
      answers: [
        { value: '16', label: 'наймані співробітники відсутні', comments: [{ general: '' }] },
      ],
      questionId: 5,
    },
    {
      answers: [
        { value: '18', label: 'не використовую транспортні засоби', comments: [{ general: '' }] },
      ],
      questionId: 6,
    },
    {
      answers: [{ value: '21', label: 'власні заощадження', comments: [{ general: '2345' }] }],
      questionId: 7,
    },
    {
      answers: [{ value: '24', label: 'не вимагає ліцензій', comments: [{ general: '' }] }],
      questionId: 8,
    },
    {
      answers: [
        { value: '26', label: 'на даний час відсутні', comments: [{ RNOKPP: '', fullName: '' }] },
      ],
      questionId: 9,
    },
    {
      answers: [{ value: '27', label: 'не плануються', comments: [{ general: '' }] }],
      questionId: 10,
    },
    {
      answers: [{ value: '30', label: 'Єдиний податок: 2 група', comments: [{ general: '' }] }],
      questionId: 11,
    },
    {
      answers: [{ value: '32', label: 'не є платником ПДВ', comments: [{ general: '' }] }],
      questionId: 12,
    },
    {
      answers: [{ value: '34', label: 'підконтрольній території', comments: [{ general: '' }] }],
      questionId: 13,
    },
  ],
};

export const testDataBusinessRelationsLegalResident = {
  businessDescription: 'Опис змісту та суті діяльності',
  typesOfActivity: {
    label: "61.20 - Діяльність у сфері безпроводового електрозв'язку",
    value: '786120',
  },
  registeredShareCapital: '7832.97',
  paidShareCapital: '2',
  isLicensed: false,
  licenses: [],
  isNonProfitOrganization: false,
  nonProfitDetails: [],
  isNewOrNonProfitEntity: false,
  explanation: [],
  isPremisesInConflictZone: false,
  premisesTypesInConflictZone: [],
  arePremisesUsedInWarZones: false,
  isIncomeReceivedFromWarZones: false,
  isEmployeesReceiveSalary: false,
  isReRegistrationAgreed: false,
  cashManagement: false,
  loans: false,
  deposits: true,
  tradeFinanceAndDocumentaryOperations: false,
  securitiesOperations: false,
  other: null,
  isTradingInfoOnCapitalMarketsProvided: false,
  tradingInfoContacts: [],
  isDepositoryInfoOnCapitalMarketsProvided: false,
  depositoryInfoContacts: [],
  type: ClientTypes.LEGAL_RESIDENT,
};
